import * as defaultConst from './clientConstant';
import CommonUtil from './commonUtil';

// const clientConfig = require('./config/clientConfig').clientConfig;

const environment = typeof env !== 'undefined' ? env : global.process.env;

const NODE_ENV =
  typeof env !== 'undefined' ? env.NODE_ENV : global.process.env.NODE_ENV; // eslint-disable-line no-undef

const clientConfigFile = require('./config/clientConfig');

const clientConfig = clientConfigFile.clientConfig[NODE_ENV];

const {
  IS_MISCOMPRAS,
  ENABLE_TOYS,
  ENABLE_ICON_TOYS,
  ENABLE_QUANTUM,
  QUANTUM_URL,
  ENABLE_NEW_HEADER,
  CRYPTO_KEY,
} = environment;

const serverClientUtil = {
  // Set channel, Brand & URL from request
  channel: '', // web
  brand: '', // LP
  appBaseURL: '', // http://localhost:3000
  showLabelKey: false,
  isLocalAsset: clientConfig.isLocalAsset,
  isGTMLoaded: false,
  enableToys: ENABLE_TOYS,
  enableIconToys: ENABLE_ICON_TOYS,
  enableQuantum: ENABLE_QUANTUM,
  quantumURL: QUANTUM_URL,
  enableNewHeader: ENABLE_NEW_HEADER,
  cryptoKey: CRYPTO_KEY,
  setShowLabelKey(lableShowKey, queryParam) {
    if (lableShowKey === 'true' && queryParam === 'true') {
      this.showLabelKey = true;
    } else {
      this.showLabelKey = false;
    }
  },
  getShowLabelKey() {
    return this.showLabelKey;
  },

  setChannel(val) {
    let _channel = defaultConst.constChannel.WEB; // default
    if (val) {
      if (val.match(/Tablet|iPad/i)) {
        _channel = defaultConst.constChannel.WEB;
      } else if (
        val.match(
          /Mobile|Windows Phone|Lumia|Android|webOS|iPhone|iPod|Blackberry|PlayBook|BB10|Opera Mini|\bCrMo\/|Opera Mobi/i,
        )
      ) {
        _channel = defaultConst.constChannel.WAP;
      } else {
        _channel = defaultConst.constChannel.WEB;
      }
    }
    this.channel = _channel;
  },

  setBrand(val) {
    this.brand = val;
  },

  setAppBaseURL(val) {
    // const _isIP = CommonUtil.ValidateIPaddress(val.substr(0, val.indexOf(':')));
    let _isIP = false;
    if (val.split(':').length > 1) {
      _isIP = CommonUtil.ValidateIPaddress(val.split(':')[1].substr(2));
    }

    if (
      clientConfig.isLocalAsset &&
      this.channel === defaultConst.constChannel.WAP &&
      _isIP
    ) {
      const _val = typeof window !== 'undefined' ? window.location.origin : val;
      this.appBaseURL = _val + '/assets';
      this.setBrand(defaultConst.constBrand.LP);
    } else if (val) {
      if (val.toLowerCase().indexOf('liverpool.') >= 0) {
        this.setBrand(defaultConst.constBrand.LP);
        this.appBaseURL = clientConfig.lpAssectURL;
      } else if (val.toLowerCase().indexOf('potterybarnkids.') >= 0) {
        this.setBrand(defaultConst.constBrand.PBK);
        this.appBaseURL = clientConfig.pbkAssectURL;
      } else if (val.toLowerCase().indexOf('williams-sonoma.') >= 0) {
        this.setBrand(defaultConst.constBrand.WS);
        this.appBaseURL = clientConfig.wsAssectURL;
      } else if (val.toLowerCase().indexOf('potterybarn.') >= 0) {
        this.setBrand(defaultConst.constBrand.PB);
        this.appBaseURL = clientConfig.pbAssectURL;
      } else if (val.toLowerCase().indexOf('gap.') >= 0) {
        this.setBrand(defaultConst.constBrand.GAP);
        // this.appBaseURL = _val + "/assetsgap"
        this.appBaseURL = clientConfig.gapAssectURL;
      } else if (val.toLowerCase().indexOf('westelm.') >= 0) {
        this.setBrand(defaultConst.constBrand.WLM);
        this.appBaseURL = clientConfig.weAssectURL;
      } else if (val.toLowerCase().indexOf('toysrus.') >= 0) {
        this.setBrand(defaultConst.constBrand.TRU);
        this.appBaseURL = clientConfig.truAssectURL;
      } else {
        this.setBrand(defaultConst.constBrand.LP);
        this.appBaseURL = clientConfig.lpAssectURL;
      }
    } else {
      this.setBrand(defaultConst.constBrand.LP);
      this.appBaseURL = clientConfig.lpAssectURL;
    }
  },

  getChannel() {
    return this.channel; // 'web';
    // return 'wap';
    // return 'store';
  },

  getBrand() {
    return this.brand;
    // return 'LP';
  },

  getAppBaseURL() {
    return this.appBaseURL;
    // return 'http://localhost:3000'
  },
  getLPFullURL(pageName) {
    const URL = this.getMultiEComSiteURL(this.getBrand());
    return (
      URL +
      (pageName === 'home'
        ? clientConfig.lpURLPriFix + '/home'
        : clientConfig.lpURLPriFix)
    );
  },

  getMultiSiteLoginURL(brandName) {
    let _url = '';
    if (brandName === defaultConst.constBrand.PB) {
      _url = clientConfig.pbLoginURL;
    } else if (brandName === defaultConst.constBrand.WS) {
      _url = clientConfig.wsLoginURL;
    } else if (brandName === defaultConst.constBrand.GAP) {
      _url = clientConfig.gapLoginURL;
    } else if (brandName === defaultConst.constBrand.PBK) {
      _url = clientConfig.pbkLoginURL;
    } else if (brandName === defaultConst.constBrand.WLM) {
      _url = clientConfig.weLoginURL;
    } else if (brandName === defaultConst.constBrand.TRU) {
      _url = clientConfig.truLoginURL;
    }

    return _url;
  },

  getATGLoginURL() {
    const URL = this.getMultiSiteLoginURL(this.getBrand());
    return URL + clientConfig.lpURLPriFix;
  },

  getMisComprasURL() {
    let url = IS_MISCOMPRAS ? '/users/miscompras' : '/users/orderHistory';
    return url;
  },

  getMisComprasText() {
    let text = IS_MISCOMPRAS ? 'Mis Compras' : 'Mis Pedidos';
    return text;
  },

  getLPURL() {
    const URL = this.getMultiEComSiteURL(this.getBrand());
    return URL;
  },
  getNavUrl(url) {
    return url.startsWith('http') ? url : this.getLPURL() + url;
  },
  getMultiSiteURL(brandName) {
    let _url = '';
    if (brandName === defaultConst.constBrand.LP) {
      _url = clientConfig.lpGRURL;
    } else if (brandName === defaultConst.constBrand.PB) {
      _url = clientConfig.pbGRURL;
    } else if (brandName === defaultConst.constBrand.WS) {
      _url = clientConfig.wsGRURL;
    } else if (brandName === defaultConst.constBrand.GAP) {
      _url = clientConfig.gapGRURL;
    } else if (brandName === defaultConst.constBrand.PBK) {
      _url = clientConfig.pbkGRURL;
    } else if (brandName === defaultConst.constBrand.WLM) {
      _url = clientConfig.wlmGRURL;
    } else if (brandName === defaultConst.constBrand.TRU) {
      _url = clientConfig.truGRURL;
    }

    return _url;
  },
  getMultiEComSiteURL(brandName) {
    return (
      brandName &&
      environment &&
      environment[`${brandName.toUpperCase()}_CMS_ECOM_URL`]
    );
  },

  getEventWebSiteURL() {
    return clientConfig.lpEventWebSiteURL;
  },
  getKalturaURL() {
    return clientConfig.KalturaAPIURL;
  },
  getKalturaPartnerID() {
    return clientConfig.KalturaPartnerID;
  },
  getKalturaSecretKey() {
    return clientConfig.KalturaSecretKey;
  },
  getKalturaUser() {
    return clientConfig.KalturaUser;
  },
  getGmailClientKey() {
    return clientConfig.gmailClientKey;
  },
  getgmailApikey() {
    return clientConfig.gmailApikey;
  },
  googlemapsapikey() {
    return clientConfig.googleMapApiKey;
  },
  templateExcelFileForGuestList() {
    return clientConfig.excelTemplate;
  },

  getOutlookRedirectUrl() {
    return clientConfig.redirectUri;
  },

  getOutlookappId() {
    return clientConfig.appId;
  },
  getYahooClientId() {
    let clientId = '';
    const brandName = this.getBrand();
    switch (brandName) {
      case defaultConst.constBrand.LP:
        clientId = clientConfig.YahooClientId;
        break;
      case defaultConst.constBrand.PB:
        clientId = clientConfig.YahooClientIdPB;
        break;
      case defaultConst.constBrand.WS:
        clientId = clientConfig.YahooClientIdWS;
        break;
      case defaultConst.constBrand.WLM:
        clientId = clientConfig.YahooClientIdWLM;
        break;
      case defaultConst.constBrand.GAP:
        clientId = clientConfig.YahooClientIdGAP;
        break;
      case defaultConst.constBrand.PBK:
        clientId = clientConfig.YahooClientIdPBK;
        break;
      case defaultConst.constBrand.TRU:
        // TODO: CHECK YAHOO CLIENT ID
        clientId = clientConfig.YahooClientIdTRU;
        break;
      default:
        clientId = '';
    }
    return clientId;
  },
  getYahooClientSecret() {
    let clientSecret = '';
    const brandName = this.getBrand();
    switch (brandName) {
      case defaultConst.constBrand.LP:
        clientSecret = clientConfig.YahooClientSecret;
        break;
      case defaultConst.constBrand.PB:
        clientSecret = clientConfig.YahooClientSecretPB;
        break;
      case defaultConst.constBrand.WS:
        clientSecret = clientConfig.YahooClientSecretWS;
        break;
      case defaultConst.constBrand.WLM:
        clientSecret = clientConfig.YahooClientSecretWLM;
        break;
      case defaultConst.constBrand.GAP:
        clientSecret = clientConfig.YahooClientSecretGAP;
        break;
      case defaultConst.constBrand.PBK:
        clientSecret = clientConfig.YahooClientSecretPBK;
        break;
      case defaultConst.constBrand.TRU:
        // TODO: CHECK YAHOO CLIENT SECRET
        clientSecret = clientConfig.YahooClientSecretTRU;
        break;
      default:
        clientSecret = '';
    }
    return clientSecret;
  },
  getYahooRedirectURI() {
    let redirectURI = '';
    const brandName = this.getBrand();
    switch (brandName) {
      case defaultConst.constBrand.LP:
        redirectURI = clientConfig.YahooRedirectURI;
        break;
      case defaultConst.constBrand.PB:
        redirectURI = clientConfig.YahooRedirectURIPB;
        break;
      case defaultConst.constBrand.WS:
        redirectURI = clientConfig.YahooRedirectURIWS;
        break;
      case defaultConst.constBrand.WLM:
        redirectURI = clientConfig.YahooRedirectURIWLM;
        break;
      case defaultConst.constBrand.GAP:
        redirectURI = clientConfig.YahooRedirectURIGAP;
        break;
      case defaultConst.constBrand.PBK:
        redirectURI = clientConfig.YahooRedirectURIPBK;
        break;
      case defaultConst.constBrand.TRU:
        // TODO: CHECK YAHOO REDIRECT URI
        redirectURI = clientConfig.YahooRedirectURITRU;
        break;
      default:
        redirectURI = '';
    }
    return redirectURI;
  },
  getYahooUserURL() {
    return clientConfig.yahooUserURL;
  },
  getMultiSiteOulookId(brandName) {
    let _url = '';
    if (brandName === defaultConst.constBrand.LP) {
      _url = clientConfig.lpGROulookId;
    } else if (brandName === defaultConst.constBrand.PB) {
      _url = clientConfig.pbGROulookId;
    } else if (brandName === defaultConst.constBrand.WS) {
      _url = clientConfig.wsGROulookId;
    } else if (brandName === defaultConst.constBrand.GAP) {
      _url = clientConfig.gapGROulookId;
    } else if (brandName === defaultConst.constBrand.PBK) {
      _url = clientConfig.pbkGROulookId;
    } else if (brandName === defaultConst.constBrand.WLM) {
      _url = clientConfig.wlmROulookId;
    } else if (brandName === defaultConst.constBrand.TRU) {
      // TODO: CHECK MULTISITE OUTLOOK ID
      _url = clientConfig.truGROulookId;
    }

    return _url;
  },
  getMultiSiteOulookRedirectUri(brandName) {
    let _url = '';
    if (brandName === defaultConst.constBrand.LP) {
      _url = clientConfig.lpGROulookRedirectUri;
    } else if (brandName === defaultConst.constBrand.PB) {
      _url = clientConfig.pbGROulookRedirectUri;
    } else if (brandName === defaultConst.constBrand.WS) {
      _url = clientConfig.wsGROulookRedirectUri;
    } else if (brandName === defaultConst.constBrand.GAP) {
      _url = clientConfig.gapGROulookRedirectUri;
    } else if (brandName === defaultConst.constBrand.PBK) {
      _url = clientConfig.pbkGROulookRedirectUri;
    } else if (brandName === defaultConst.constBrand.WLM) {
      _url = clientConfig.wlmGROulookRedirectUriL;
    } else if (brandName === defaultConst.constBrand.TRU) {
      // TODO: CHECK MULTISITE OUTLOOK REDIRECT URI
      _url = clientConfig.truGROulookRedirectUri;
    }

    return _url;
  },
  getFacebookAppId(brandName) {
    let appId = '';
    if (brandName === defaultConst.constBrand.LP) {
      appId = clientConfig.lpfacebookAppId;
    } else if (brandName === defaultConst.constBrand.PB) {
      appId = clientConfig.pbfacebookAppId;
    } else if (brandName === defaultConst.constBrand.WS) {
      appId = clientConfig.wsfacebookAppId;
    } else if (brandName === defaultConst.constBrand.GAP) {
      appId = clientConfig.gapfacebookAppId;
    } else if (brandName === defaultConst.constBrand.PBK) {
      appId = clientConfig.pbkfacebookAppId;
    } else if (brandName === defaultConst.constBrand.WLM) {
      appId = clientConfig.wlmfacebookAppId;
    } else if (brandName === defaultConst.constBrand.TRU) {
      // TODO: CHECK FACEBOOK APP ID
      appId = clientConfig.trufacebookAppId;
    }
    return appId;
  },

  brandNames(brandName) {
    let currentBrandName = '';
    if (brandName === defaultConst.constBrand.LP) {
      currentBrandName = 'Liverpool';
    } else if (brandName === defaultConst.constBrand.PB) {
      currentBrandName = 'Pottery Barn';
    } else if (brandName === defaultConst.constBrand.WS) {
      currentBrandName = 'William Sonama';
    } else if (brandName === defaultConst.constBrand.GAP) {
      currentBrandName = 'GAP';
    } else if (brandName === defaultConst.constBrand.PBK) {
      currentBrandName = 'Pottery Barn Kids';
    } else if (brandName === defaultConst.constBrand.WLM) {
      currentBrandName = 'West Elm';
    } else if (brandName === defaultConst.constBrand.TRU) {
      currentBrandName = 'Toys r us';
    }
    return currentBrandName;
  },

  getGTMKey(brandName) {
    let _GTMKey = {};
    if (brandName === defaultConst.constBrand.LP) {
      _GTMKey = clientConfig.lpTagging;
    } else if (brandName === defaultConst.constBrand.PB) {
      _GTMKey = clientConfig.pbTagging;
    } else if (brandName === defaultConst.constBrand.WS) {
      _GTMKey = clientConfig.wsTagging;
    } else if (brandName === defaultConst.constBrand.GAP) {
      _GTMKey = clientConfig.gapTagging;
    } else if (brandName === defaultConst.constBrand.PBK) {
      _GTMKey = clientConfig.pbkTagging;
    } else if (brandName === defaultConst.constBrand.WLM) {
      _GTMKey = clientConfig.wlmTagging;
    } else if (brandName === defaultConst.constBrand.TRU) {
      // TODO: CHECK GTM KEY
      _GTMKey = clientConfig.truTagging;
    }

    return _GTMKey;
  },

  getGoogleMapApiKey() {
    let googleMapKey = '';
    const brandName = this.getBrand();
    switch (brandName) {
      case defaultConst.constBrand.LP:
        googleMapKey = clientConfig.googleMapApiKeyLP;
        break;
      case defaultConst.constBrand.PB:
        googleMapKey = clientConfig.googleMapApiKeyPB;
        break;
      case defaultConst.constBrand.WS:
        googleMapKey = clientConfig.googleMapApiKeyWS;
        break;
      case defaultConst.constBrand.WLM:
        googleMapKey = clientConfig.googleMapApiKeyWLM;
        break;
      case defaultConst.constBrand.GAP:
        googleMapKey = clientConfig.googleMapApiKeyGAP;
        break;
      case defaultConst.constBrand.PBK:
        googleMapKey = clientConfig.googleMapApiKeyPBK;
        break;
      case defaultConst.constBrand.TRU:
        googleMapKey = clientConfig.googleMapApiKeyTRU;
        break;
      default:
        googleMapKey = '';
    }
    return googleMapKey;
  },
};

export default serverClientUtil;
